function updateImageHeight() {
  const images = document.querySelectorAll('.collection-list-slider-item .collection-slider_image');
  if (images.length <= 0) {
    return
  }
  images.forEach((slide, index) => {
    const slideWidth = slide.offsetWidth; // Get the width of the image so we can set the same height
    if (images[index]) {
      images[index].style.height = `${slideWidth}px`;
      images[index].style.maxHeight = `${slideWidth}px`;
    }
  });
}

// Observe size changes in .collection-slider_image. The width of this element is dynamically set inside
const images = document.querySelectorAll('.collection-list-slider-item .collection-slider_image');
images.forEach((slide) => {
  const resizeObserver = new ResizeObserver(() => {
    updateImageHeight(); // Run whenever the size of the slide changes
  });
  resizeObserver.observe(slide);
});

// Run on page load
window.addEventListener('load', updateImageHeight);
window.addEventListener('resize', updateImageHeight);


// Select all elements with the class .glide__arrow
const glideArrows = document.querySelectorAll('.glide__arrow');

// Function to handle the addition of display: none with a delay
function handleArrowDisable() {
  glideArrows.forEach(arrow => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === "class") {
          if (arrow.classList.contains('glide__arrow--disabled')) {
            setTimeout(() => {
              arrow.style.display = 'none';
            }, 250); // 500ms delay before setting display to none
          } else {
            // Reset display when the class is removed
            arrow.style.display = '';
          }
        }
      });
    });

    observer.observe(arrow, { attributes: true });

    // Trigger the logic on load
    if (arrow.classList.contains('glide__arrow--disabled')) {
      arrow.style.display = 'none';
    }
  });
}

// Initialize the handler
document.addEventListener('DOMContentLoaded', handleArrowDisable);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const drawerUnderlay = document.querySelector(".mobile-nav__underlay");
    const showUnderlay = "visibility: visible; opacity: 1;";
    const hideUnderlay = "visibility: hidden; opacity: 0;";

    this.underlayClickHandler = this.onUnderlayClick.bind(this);
    drawerUnderlay.addEventListener("pointerdown", this.underlayClickHandler);

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
      isOpen
        ? (drawerUnderlay.style = hideUnderlay)
        : (drawerUnderlay.style = showUnderlay);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  onUnderlayClick(event) {
    const drawerUnderlay = document.querySelector(".mobile-nav__underlay");
    drawerUnderlay.removeEventListener(
      "pointerdown",
      this.underlayClickHandler
    );
    this.closeMenuDrawer(event);
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    var html = document.querySelector("html");
    html.classList.add("overflow-hidden-mobile");

    const underlay = document.querySelector(".mobile-nav__underlay");
    underlay.addEventListener("pointerdown", (event) =>
      this.onUnderlayClick(event)
    );
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      const drawerUnderlay = document.querySelector(".mobile-nav__underlay");
      const hideUnderlay = "visibility: hidden; opacity: 0;";
      drawerUnderlay.style = hideUnderlay;
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      var html = document.querySelector("html");
      html.classList.remove("overflow-hidden-mobile");
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    var html = document.querySelector("html");
    html.classList.add("overflow-hidden-mobile");
  }
}

customElements.define("header-drawer", HeaderDrawer);

// Get container that contains the items that are loaded async
const reviewTargetNodes = document.querySelectorAll('.review-widget-container');

// Function to handle hiding elements
const handleHideElements = (targetNode) => {
  const totalReviewsElements = targetNode.querySelector('.total_reviews');
  const ratingStarsElements = targetNode.querySelector('.rating-stars');

  if (ratingStarsElements && totalReviewsElements && totalReviewsElements.textContent === '0') {
    totalReviewsElements.style.display = 'none';
    ratingStarsElements.style.display = 'none';
    targetNode.style.display = 'none';
  }
};

// Create a new MutationObserver instance
const reviewObserver = new MutationObserver(() => {
  reviewTargetNodes.forEach(targetNode => {
    if (document.contains(targetNode)) {
      handleHideElements(targetNode);
    }
  });
});

// Configure and start observing the targetNode for mutations
if (reviewTargetNodes.length > 0) { // Check if there are any target nodes
  reviewTargetNodes.forEach(targetNode => {
    reviewObserver.observe(targetNode, { childList: true, subtree: true });
  });
}



var isSidebarVisible = false;

function toggleSidebar() {
  isSidebarVisible = !isSidebarVisible;
  updateSidebarVisibility();
}

function closeSidebar() {
  isSidebarVisible = false;
  updateSidebarVisibility();
}

function updateSidebarVisibility() {
  var page = document.querySelector("html");

  var sidebar = document.getElementById('sidebar');
  page.classList.toggle("sidebar-visible");

  sidebar.classList.toggle('visible', isSidebarVisible);
}

var accordionItems = document.querySelectorAll('.spraypay-accordion-name')
accordionItems.forEach(item => {
  item.addEventListener("click", (event) => {
    item.classList.toggle('opened');
  });
});

document.addEventListener("DOMContentLoaded", (event) => {

  const scrollableBlocks = document.querySelectorAll('.mattress-picker-banner');

  scrollableBlocks.forEach(block => {
    var scrollableContainer = block.querySelector('.scroll-container');
    var pagination = block.querySelector('.pagination');
    var children = scrollableContainer.querySelectorAll('.banner-container');

    function createDots() {
      children.forEach((child, index) => {
        const dot = document.createElement('span');
        dot.classList.add('dot');

        if (index === 0) dot.classList.add('active');

        pagination.appendChild(dot);
      });
    }

    // Function to update the active dot based on scroll position for the specific block
    function updateActiveDot() {
      const containerWidth = scrollableContainer.offsetWidth;
      const scrollLeft = scrollableContainer.scrollLeft;

      // Adjust activeIndex to account for partial slide visibility
      const activeIndex = Math.round(scrollLeft / (containerWidth * 0.75));

      const dots = pagination.querySelectorAll('.dot');
      dots.forEach(dot => dot.classList.remove('active'));

      dots[activeIndex].classList.add('active');
    }

    createDots();

    scrollableContainer.addEventListener('scroll', updateActiveDot);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const mobileForm = document.getElementById('CollectionFiltersForm2');
  const desktopForm = document.getElementById('CollectionFiltersForm3');
  const filterForms = [mobileForm, desktopForm];

  // Handle "Show more" buttons
  document.querySelectorAll('.show-more-btn').forEach(button => {
    button.addEventListener('click', function () {
      const index = button.getAttribute('data-target');
      const group = button.closest('form').querySelector(`.filter-group[data-filter-index="${index}"]`);
      if (group) {
        group.querySelectorAll('li.hidden').forEach(item => item.classList.remove('hidden'));
        button.style.display = 'none';
      }
    });
  });

  // Auto-submit on checkbox change using event delegation
  setTimeout(() => {
    filterForms.forEach(form => {
      if (form) {
        form.addEventListener('change', function (e) {
          if (e.target && e.target.type === 'checkbox') {
            form.submit();
          }
        });
      }
    });
  }, 300); // Delay if elements are rendered late

  // Mobile sidebar toggle logic
  const openFiltersBtn = document.getElementById('openFiltersBtn');
  const closeFiltersBtn = document.getElementById('closeFiltersBtn');
  const mobileFilterSidebar = document.getElementById('mobileFilterSidebar');
  const sidebarOverlay = document.getElementById('sidebarOverlay');

  function openSidebar() {
    mobileFilterSidebar.classList.add('active');
    mobileFilterSidebar.classList.remove('hidden');
    sidebarOverlay.classList.remove('hidden');
  }

  function closeSidebar() {
    mobileFilterSidebar.classList.remove('active');
    sidebarOverlay.classList.add('hidden');
  }

  openFiltersBtn?.addEventListener('click', openSidebar);
  closeFiltersBtn?.addEventListener('click', closeSidebar);
  sidebarOverlay?.addEventListener('click', closeSidebar);

  // Show/hide correct form based on screen size
  function updateFormVisibility() {
    const isMobile = window.innerWidth <= 768;
    if (desktopForm) desktopForm.style.display = isMobile ? 'none' : 'block';
    if (mobileForm) mobileForm.style.display = isMobile ? 'block' : 'none';
  }

  updateFormVisibility();
  window.addEventListener('resize', updateFormVisibility);
});


